var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0886 4.41058C13.414 4.73602 13.414 5.26366 13.0886 5.58909L8.67786 9.99984L13.0886 14.4106C13.414 14.736 13.414 15.2637 13.0886 15.5891C12.7632 15.9145 12.2355 15.9145 11.9101 15.5891L6.91009 10.5891C6.58466 10.2637 6.58466 9.73602 6.91009 9.41058L11.9101 4.41058C12.2355 4.08514 12.7632 4.08514 13.0886 4.41058Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronLeft);
export default __webpack_public_path__ + "static/media/ic-chevron-left.82ecc938d1014fd92cabffdc1c024b1e.svg";
export { ForwardRef as ReactComponent };